export default __webpack_public_path__ + "static/media/wheel-accept.ff05f64f.png";